export default __webpack_public_path__ + "static/media/RAISIN.03bb50eb.jpg";